import { Styles } from '../../theme/materialTheme';

export const loginByBankIDContainer: Styles = {
  mt: 3.5,
};
